import { Link as GatsbyLink } from 'gatsby';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import React from 'react';

export const Link = ({ link, className }) => {
  if (!link || !link.title || !link.url) return null;

  if (link.url.includes('#'))
    return (
      <AnchorLink stripHash to={link.url} className={['btn mt-4', className].join(' ')}>
        {link.title}
      </AnchorLink>
    );

  return (
    <GatsbyLink to={link.url} className={['btn mt-4', className].join(' ')}>
      {link.title}
    </GatsbyLink>
  );
};
